<script setup>
// NOTICE: KAPTION-INTEGRATION
// Campaign Indicator component to display campaign icon in conversation list

import { computed } from 'vue';

const props = defineProps({
  chat: {
    type: Object,
    required: true,
  },
});

// Get campaign title from conversation data
// Campaign data is in chat.meta.campaign (from API response structure)
const campaignTitle = computed(() => {
  // Check meta.campaign first (as per API structure in _conversation.json.jbuilder)
  if (props.chat?.meta?.campaign?.title) {
    return props.chat.meta.campaign.title;
  }
  // Fallback to direct campaign property (in case structure changes)
  if (props.chat?.campaign?.title) {
    return props.chat.campaign.title;
  }
  return null;
});

const hasCampaign = computed(() => {
  return !!campaignTitle.value;
});
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <span
    v-if="hasCampaign"
    v-tooltip="{
      content: campaignTitle,
      delay: { show: 1500, hide: 0 },
      hideOnClick: true,
    }"
    class="shrink-0 rounded-sm inline-flex items-center justify-center w-2.5 h-2.5 bg-n-amber-4 text-n-amber-11"
  >
    <fluent-icon icon="megaphone" size="10" class="flex-shrink-0" />
  </span>
</template>
